<div class="campaign-successful-container">
  <ngx-app-bar
    class="w-100"
    [title]="'دریافت جایزه گنج'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="campaign-successful-content">
    <img src="wealth-assets/images/treasure-hunt-3.png" />
    <p class="campaign-successful-title">جایزه {{ state?.instrumentName }} شما آماده‌است!</p>
    <div class="campaign-successful-description">
      <span>
        شما {{ state?.prizeAmount }} ریال جایزه صندوق {{ state?.instrumentName }} را دریافت کرده‌اید. دارایی خود را می‌توانید در صفحه جزئیات
        صندوق مشاهده کنید.
      </span>
    </div>
  </div>
  <div class="campaign-successful-buttons">
    <ngx-button
      [buttonId]="'CAMPAIGN_CONFIRM_TREASURY'"
      [style]="'tinted-on-elevated'"
      [fullWidth]="true"
      [mode]="'form'"
      size="medium"
      (click)="onBackHandler()"
    >
      متوجه شدم
    </ngx-button>
    <ngx-button
      [buttonId]="'CAMPAIGN_VIEW_ASSETS'"
      [style]="'fill'"
      [fullWidth]="true"
      [mode]="'form'"
      size="medium"
      (click)="onViewAssets()"
    >
      مشاهده دارایی
    </ngx-button>
  </div>
</div>
